if (!customElements.get('clinicians-choice')) {
  customElements.define(
    'clinicians-choice',
    class CliniciansChoice extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        if (!this.dataset.frontrowProductId) return;

        for (const link of this.querySelectorAll('.clinicians-choice__text a')) {
          link.setAttribute('aria-haspopup', 'dialog');
        }

        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      /**
       * Opens the FrontrowMD modal (created by their widget script) instead of following the link.
       * Falls through to normal navigation if the widget script has not loaded.
       * @param {MouseEvent} event
       * @returns {void}
       */
      onClick(event) {
        const link = event.target.closest('.clinicians-choice__text a');
        if (!link) return;
        if (!document.getElementById('frontrow-portal')) return;

        event.preventDefault();
        window.postMessage('OPEN_MODAL_STICKER', window.location.origin);
      }
    },
  );
}
